var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"exit"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.logout()}}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }